export default {
    namespaced: true,
    pages: {
      title: "page | pages",
      description: "description",
      url: "URL",
      facilities: "Facilities",
      shared: "shared",
    },
  }
